var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M11.13 96.462h489.739v319.076H11.13z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M246.342 363.726c-2.333-1.999-57.125-49.632-57.125-107.731s54.792-105.732 57.125-107.731l9.658-8.279 9.658 8.279c2.333 1.999 57.125 49.632 57.125 107.731s-54.792 105.732-57.125 107.731L256 372.005l-9.658-8.279z",
  fill: "#d80027"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M307.942 255.994c0-51.942-51.942-96.464-51.942-96.464s-51.942 44.524-51.942 96.464c0 15.89 4.865 31.083 11.613 44.522h80.658c6.748-13.439 11.613-28.632 11.613-44.522z",
  fill: "#338af3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M307.942 255.994c0 15.89-4.865 31.083-11.613 44.522L256 307.937l-40.329-7.421c-6.748-13.439-11.613-28.632-11.613-44.522h103.884z",
  fill: "#0052b4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M256 352.459s25.019-21.452 40.329-51.942h-80.658c15.31 30.49 40.329 51.942 40.329 51.942z",
  fill: "#ffda44"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M222.609 226.313h66.782L256 259.704z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M244.87 248.57h22.261v66.783H244.87z"
})));

export default SvgGu;